import {ChangeDetectionStrategy, Component, inject, Input, OnChanges, SimpleChanges} from "@angular/core";
import {Store} from "@ngrx/store";
import {Router} from "@angular/router";
import {FundAiSetupActions} from "../store/fund-ai-setup.actions";
import {selectActiveJobForFund, selectMostRecentReadyJobForFund} from "../store/fund-ai-setup.selectors";

@Component({
    selector: "valumize-fund-ai-setup-status-chip",
    templateUrl: "./fund-ai-setup-status-chip.component.html",
    styleUrls: ["./fund-ai-setup-status-chip.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FundAiSetupStatusChipComponent implements OnChanges {

    @Input({required: true}) fundId!: number;

    private readonly store = inject(Store);
    private readonly router = inject(Router);

    activeJob$ = this.store.select(selectActiveJobForFund(0));
    readyJob$ = this.store.select(selectMostRecentReadyJobForFund(0));

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["fundId"] && this.fundId) {
            this.activeJob$ = this.store.select(selectActiveJobForFund(this.fundId));
            this.readyJob$ = this.store.select(selectMostRecentReadyJobForFund(this.fundId));
            this.store.dispatch(FundAiSetupActions.loadJobs({fundId: this.fundId}));
        }
    }

    openReview(taskInfoId: number) {
        this.router.navigate(["/fund-ai-setup", taskInfoId]);
    }
}
